import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProposalRepositoryService } from './proposal-repository.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialogComponent } from 'src/app/components/delete-dialog/delete-dialog.component';
import { TemplateUploadModalComponent } from '../template-upload-modal/template-upload-modal.component';
import { EditTemplateModalComponent } from 'src/app/components/edit-template-modal/edit-template-modal.component';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { SlickCarouselComponent } from 'ngx-slick-carousel';



@Component({
  selector: 'app-proposal-repository',
  templateUrl: './proposal-repository.component.html',
  styleUrls: ['./proposal-repository.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('revealAnimation', [
      // State styles
      state('void', style({ opacity: 0, transform: 'translateX(100%)' })),
      state('*', style({ opacity: 1, transform: 'translateX(0)' })),

      // Transition animations
      transition('void <=> *', animate('1000ms ease-in-out')),
    ])
  ]
})

export class ProposalRepositoryComponent implements OnInit, AfterViewInit {
  @ViewChild('carousel') carouselRef: ElementRef;
  @ViewChild('proposalsCarousel') proposalsCarousel: SlickCarouselComponent;
  @ViewChild('templatesCarousel') templatesCarousel: SlickCarouselComponent;
  @ViewChild('documentsCarousel') documentsCarousel: SlickCarouselComponent;
  carouselConfig = {
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: true, // Enable right-to-left mode
    // Add other configuration options as needed
  };


  throttle = 0;

  distance = 2;

  public searchText: string;
  public size: number = 6;
  public from: number;
  public cardsTitle: string;
  public data: any;
  public showViewMore: boolean;
  public totalcount: number;
  public proposalCardsTitle = "#Recent 8";
  public dataItems: any = [];
  public showProposalCards = false;
  public loader: boolean = false;
  public referenceDocuments: any = [];
  public showgroup: boolean = false;
  public groupName: string;
  tabIndex: number = 0;
  checkedValuesArray: any = [];
  temporaryCheckedValue: { name: any; value: any; };
  dataItemsnew: any = [];
  aa: any = [];
  temp: boolean = true;
  id: number = 1;
  public dataItemsTemporary: any = [];
  scrolledData: any = [];
  dataItems2: any = [];
  busyGettingData: boolean = false;
  dataItems3: any = [];
  recentItems: any;
  constructor(private router: Router, private _service: ProposalRepositoryService, private toastr: ToastrService, public dialog: MatDialog, private cd: ChangeDetectorRef, private elementRef: ElementRef, private auth: AuthServiceService) { }
  public groupByList = []

  ngOnInit() {
    this.searchText = "";
    this.tabIndex = Number(localStorage.getItem('proposalTabIndex'));
    this.loadReferenceDocumnets("");
    this.loadInitialData();
    this.groupByList = [
      {
        name: 'Competency',
        value: 'ServiceLine',
        value2: 'serviceLine'
      },
      {
        name: 'Domain',
        value: 'Domain',
        value2: 'domain'
      },
      {
        name: 'Location',
        value: 'Location',
        value2: 'location'
      },
      {
        name: 'Proposal Status',
        value: 'ProposalStatus',
        value2: 'proposalStatus'
      },
      {
        name: 'Size',
        value: 'Size',
        value2: 'size'
      },
      {
        name: 'Delivery Methodology',
        value: 'DeliveryMethod',
        value2: 'deliveryMethodology'
      },
      {
        name: 'Service Offering',
        value: 'ServiceOffering',
        value2: 'servicesOffering'
      },
      {
        name: 'Tech Stack',
        value: 'TechStack',
        value2: 'techStack'
      },
      {
        name: 'Primary Prospect',
        value: 'PrimaryProspect',
        value2: 'primaryProspect'
      }

    ];
    this.groupByList.map((item, index) => {
      this._service.getProposalDataByGroup(item.value == "Location" ? "Customer." + item.value : item.value).subscribe(x => {
        let keydatas = []
        x.data.map((data) => {
          data.checked = true;

          let aa = { checked: data.checked, key: data.key }

          keydatas.push(aa);

        })

        item.key = keydatas;




      }, error => {
        this.groupName = item.value;
      })
    });

    this.getAllProposals();

  }

  ngAfterViewInit() {
    // Initialize the carousels
    this.proposalsCarousel.slickNext;
    this.templatesCarousel.slickNext;
    this.documentsCarousel.slickNext;
  }
  accordionState: { [key: string]: boolean } = {};
  accord = [true, false]
  toggleAccord(num) {
    this.accord[0] = !this.accord[0]
    this.accord[1] = !this.accord[1]
  }
  toggleAccordion(key: string) {
    this.accordionState[key] = !this.accordionState[key];

    // Collapse previously open accordions
    Object.keys(this.accordionState).forEach((accordionKey) => {
      if (accordionKey !== key) {
        this.accordionState[accordionKey] = false;
      }
    });
  }


  isAccordionOpen(key: string): boolean {
    return this.accordionState[key] || false;
  }


  resetAccordionState(key: string) {
    Object.keys(this.accordionState).forEach((accordionKey) => {
      if (accordionKey !== key) {
        this.accordionState[accordionKey] = false;
      }
    });
  }



  onTabChanged(event) {
    this.tabIndex = event.index;
    localStorage.setItem('proposalTabIndex', event.index);
  }

  openEditTemplate(data) {
    data.templateDescription = data.description;
    const dialogRef = this.dialog.open(EditTemplateModalComponent, {
      width: '450px',
      height: '310px',
      data
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.loader = true;
      this._service.editReferenceDocument(res).subscribe((res) => {
        data.description = data.templateDescription;
        this.loader = false;
        this.toastr.success(res.message);
      }, error => {
        this.loader = false;
        this.toastr.error('Something went wrong');
      })
    })
  }
  loadInitialData(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.loader = true;
      this.from = 0;
      this.showViewMore = false;
      this._service.getProposalData(null, this.searchText, this.from, this.size).subscribe(x => {
        this.dataItems = x.data.proposals;

        this.recentItems = x.data.proposals.filter(proposal => {
          const proposalCreatedDate = new Date(proposal.createdOn);
          const today = new Date();
          const oneWeekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
          return proposalCreatedDate >= oneWeekAgo && proposalCreatedDate <= today;
        });
        this.dataItemsTemporary = this.dataItems;

        this.showProposalCards = true;
        this.totalcount = x.data.totalCount;
        if (this.totalcount > this.from + this.size) {
          this.showViewMore = true;
        }
        else {
          this.showViewMore = false;
        }
        this.loader = false;
        resolve(this.dataItems);
      }
      );
    })

  }
  loadReferenceDocumnets(data) {
    this._service.getRefDoc("", 0, 50).subscribe(x => {
      this.referenceDocuments = x.data.items;
      this.loader = false;
      if (data != "")
        this.toastr.success(data)
      this.cd.detectChanges();
    }, error => {
      this.referenceDocuments = [];
      this.loader = false;
      this.cd.detectChanges();
    })
  }
  addButton() {
    this.router.navigate(['Home/add-proposal'])
  }
  backButton() {
    this.router.navigate(['/Home'])
  }
  clearSearch() {
    if (this.searchText == "") {
      this.searchButton()
    }
  }
  clearSearchText() {
    this.searchText = "";
    this.loadInitialData();
  }
  activeTab: string = 'proposals';
  previousTab: string = '';

  changeTab(tab: string) {
    this.previousTab = this.activeTab;
    this.activeTab = tab;
  }

  searchButton() {
    this.loader = true;

    this.showgroup = false;
    this.from = 0;
    this.showViewMore = false;
    this._service.getProposalData(null, this.searchText, this.from, this.size).subscribe(x => {
      this.dataItems = x.data.proposals.filter((item) => item.customerName.toLowerCase().includes(this.searchText.toLowerCase()));
      this.totalcount = x.data.totalCount;
      if (this.totalcount > this.from + this.size) {
        this.showViewMore = true;
      }
      else {
        this.showViewMore = false;
      }
      this.loader = false;

    }, error => {
      this.dataItems = [];
      this.loader = false;
      this.showViewMore = false;
    })
    this.proposalCardsTitle = "";
  }
  viewMore() {
    this.from += this.size;
    this.loader = true;

    this._service.getProposalData(null, this.searchText, this.from, this.size).subscribe(x => {
      this.dataItems = this.dataItems.concat(x.data.proposals);

      this.totalcount = x.data.totalCount;
      this.loader = false;
    })
    if (this.totalcount <= this.from + this.size) {
      this.showViewMore = false;
    }
    this.proposalCardsTitle = "";
  }
  openDeleteDialog(data) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: {
        name: data.serviceLine,
        title: "Delete Proposal"
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader = true;
        this.deleteProposalCard(data.id);
      }
    });

  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    $('#sidebar_r').removeClass('active');
    $('#sidebar').removeClass('active');
    $('.overlay').removeClass('active');
  }
  deleteProposalCard(id) {
    this._service.delPropsalData(id).subscribe(res => {
      setTimeout(() => {
        this.loadData("Proposal Card deleted successfully")
      }, 1000);
    })
  }
  loadData(data) {
    this._service.getProposalData(null, this.searchText, 0, this.from + this.size).subscribe(x => {
      if (x.data) {
        this.dataItems = x.data.proposals;
        this.totalcount = x.data.totalCount;
        this.loader = false;
      }
      else {
        this.dataItems = [];
      }
    })
  }

  async actionMethods(data) {
    if (data.Action == "delete") {
      this.openDeleteDialog(data.data);

    }
    else if (data.Action == "view") {
      this.router.navigate(['Home/Proposal Repository/view/' + data.id]);
    }
    else if (data.Action == "edit") {
      this.router.navigate(['Home/Proposal Repository/edit/' + data.id]);
    }
    else {
      this.loader = true;
      this._service.downloadProposal(data.data.id).subscribe(res => {
        res.data.forEach(x => {
          var a = document.createElement("a");
          a.href = `data:${x.mimeType};base64,${x.data}`;
          a.download = x.name; //File name Here
          a.click();
          a.remove();
        })
        setTimeout(() => {
          this.loadData("All attachments downloaded successfully");
        }, 1000);
      }, error => {
        this.loader = false;
        this.toastr.error("No Attachments to Download")
      })
    }
  }
  addRefDocButton() {
    const dialogRef = this.dialog.open(TemplateUploadModalComponent, {
      width: '1012px',
      height: '498px',
      panelClass: 'view-file',
    });
    dialogRef.afterClosed().subscribe(result => {
      result.forEach(x => {
        this.loader = true;
        x.description = x.templateDescription;
        this._service.addRefDoc(x).subscribe(res => {
          setTimeout(() => {
            this.loadReferenceDocumnets("Attachments added successfully")
          }, 5000);
        })
      })
    });
  }
  DeleteTemplate(doc) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: {
        name: doc.name,
        title: "Delete Artifactory"
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader = true;
        this.deleteRefDoc(doc.id, doc.sharepointId);
      }
    });
  }
  deleteRefDoc(id, sharepointId) {
    this._service.delRefDoc(id, sharepointId).subscribe(x => {
      setTimeout(() => {
        this.loadReferenceDocumnets("attachment deleted successfully");
      }, 1000);
    })
  }
  downloadTemplate(id, sharepointId) {

    this.loader = true;
    this._service.downloadRefDoc(id, sharepointId).subscribe(x => {
      var file = x.message;
      var a = document.createElement("a");
      a.href = file;
      a.click();
      a.remove();
      setTimeout(() => {
        this.loadReferenceDocumnets("Attachment downloaded successfully");
      }, 500);
    })
  }
  GroupBy(event) {

    if ($('#sidebar').hasClass('active')) {
      $('#sidebar').removeClass('active')
    }
    $('#sidebar_r').addClass('active');
    $('.overlay').addClass('active');
    $('.collapse.in').toggleClass('in');
    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    event.stopPropagation();
  }
  getGroupName(str) {
    str = str.split(/(?=[A-Z])/);
    var groupName = ""
    str.forEach(x => {
      groupName = groupName + x + " ";
    })
    return groupName;
  }
  getFilterValues(data) {
    var group = data.groupBy;
    if (group == null) {
      this.showgroup = false;
      this.loadInitialData();
    }
    else {
      this.loader = true;
      this._service.getProposalDataByGroup(group == "Location" ? "Customer." + group : group).subscribe(x => {
        this.dataItems = x.data;
        this.showgroup = true;
        this.loader = false;
        this.groupName = group;

      }, error => {
        this.dataItems = [];
        this.loader = false;
        this.showgroup = true;
        this.showViewMore = false;
        this.groupName = group;
      })
    }
  }

  isAuthorizedUser(data) {
    var roles = this.auth.getRole();
    if (roles.indexOf('SuperAdmin') >= 0 || roles.indexOf('Proposal.Admin') >= 0)
      return true
    else {
      if (roles.indexOf('Proposal.User') >= 0) {
        if (data.createdBy == this.auth.getEmailId())
          return true;
      }
    }
    return false;
  }


  onChange(groupByKey: any, checkedValue: any, isChecked: boolean) {
    this.busyGettingData = false;

    for (var i = 0; i < this.groupByList.length; i++) {
      if ((this.groupByList[i].name.toLowerCase()) == (groupByKey.toLowerCase())) {
        this.temporaryCheckedValue = {
          name: this.groupByList[i].value2,
          value: checkedValue
        };

      };

    }
    if (isChecked) {
      this.checkedValuesArray.push(this.temporaryCheckedValue);


    }
    else {
      if (this.checkedValuesArray.length > 0) {
        let index = this.checkedValuesArray.findIndex(obj => obj.value === this.temporaryCheckedValue.value && obj.name === this.temporaryCheckedValue.name);

        if (index >= 0) {
          this.checkedValuesArray.splice(index, 1);
        }
      }


    }

    if (this.checkedValuesArray.length > 0) {

      let arr1 = this.checkedValuesArray;
      let arr2 = this.dataItems2;
      this.dataItemsnew = this.filterObjects(arr1, arr2);

      this.dataItems3 = this.dataItemsnew;
      this.dataItems = this.dataItemsnew.slice(0, 6)
        ;
    }
    if (this.checkedValuesArray.length == 0) {
      this.dataItems3 = this.dataItems2;
      this.dataItems = this.dataItems2.slice(0, 6);
      this.busyGettingData = false;

    }

  }


  filterObjects(arr1, arr2) {
    return arr2.filter(obj2 => {
      let correspondingObj = arr1.find(obj1 => obj1.name in obj2);
      if (correspondingObj && obj2[correspondingObj.name].includes(correspondingObj.value)) {
        return true;
      }
      return false;
    });
  }


  onScroll(): void {

    if (this.busyGettingData) {
      return
    }

    this.size = 3;
    this.from = this.dataItems.length;


    {
      let to = this.size + this.from;
      this.scrolledData = this.dataItems3.slice(this.from, to);

      if (this.scrolledData.length == 0) {
        this.busyGettingData = true

      }



      for (var data of this.scrolledData) {

        this.dataItems = [...this.dataItems, data]

      }
    }
  }


  getAllProposals() {

    this._service.getAllProposals(this.searchText).subscribe(x => {
      this.dataItems2 = x.data.proposals;
      this.dataItems = this.dataItems2.slice(0, 6);
      this.dataItems3 = this.dataItems2;
    })
  }

}